import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@material-ui/core";

import { getData } from "../../../../../services";
import { COLORS } from "../../../../../theme/colors";
import { BuildingListView } from "./buildingListView";
import { BuildingStatusView } from "./buildingStatusView";
import { Toggle } from "../../../../../components/toggle";
import endPoints from "../../../../../services/apiEndPoints";
import { USER_ROLES } from "../../../../../services/constants";
import { ActionButtonsGroup } from "../../../../../components/buttonsGroup/ActionButtonsGroup";

const VIEW_STATUS = "Status";
const VIEW_LIST = "List";

export const OnboardingStatusTab = () => {
  const [buildings, setBuildings] = useState([]);
  const [statusCount, setStatusCount] = useState([]);
  const { cluster, segments, selectedCountries } = useSelector((state) => state.selectCSC);
  const [view, setView] = useState(cluster?.user_role === USER_ROLES.bop ? VIEW_STATUS : VIEW_LIST);

  useEffect(() => {
    if (cluster) initData();
  }, [cluster, segments, selectedCountries]);

  const initData = () => {
    getData(endPoints.OB_TASKS_GET_BUILDINGS, (data) => setBuildings(data.results));
    getData(endPoints.OB_TASKS_STATUS, (data) => setStatusCount(data));
  };

  const ViewComponent = {
    [VIEW_LIST]: BuildingListView,
    [VIEW_STATUS]: BuildingStatusView,
  }[view];

  const onViewChanged = (v) => {
    if (cluster?.user_role !== USER_ROLES.bop) {
      setView(v);
    }
  };

  return (
    <Box mt={2.5}>
      <Box
        mt={2}
        mb={1}
        display="flex"
        flexWrap="wrap"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography style={{ fontWeight: "bold" }}>
          {cluster.user_role === USER_ROLES.bop
            ? `ONBOARDING - ${buildings.length} BUILDING${
                buildings.length > 0 ? "s" : ""
              }`
            : "PORTFOLIO ONBOARDING STATUS"}
        </Typography>
        <Grid container alignItems="center" style={{ width: "fit-content" }}>
          <Toggle
            value={view}
            options={[VIEW_STATUS, VIEW_LIST]}
            width={50}
            onChanged={onViewChanged}
          />
          <Box width={2} height={30} bgcolor={COLORS.darks[0][25]} ml={2} />
          <ActionButtonsGroup />
        </Grid>
      </Box>
      <ViewComponent
        buildings={buildings}
        statusCount={statusCount}
        onReload={initData}
      />
    </Box>
  );
};
